import React, { useMemo } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { Box, Button, IconButton, Tooltip, Chip, Typography } from '@mui/material';
import { Delete, Edit, Add } from '@mui/icons-material';

import CustomDialog from '../../../layout/CustomDialog';
import HomologationPessoaDialog from './HomologationPessoaDialog';

function PessoasTabPanel({ module }) {
    const { state, actions, dialogs, mrt, context } = module;

    const columns = useMemo(
        () => [
            {
                accessorKey: 'pessoa',
                header: 'Pessoa',
                muiTableBodyCellProps: ({ row }) => ({
                    onClick: () => {
                        console.info(row.original);
                    },
                }),
                Cell: ({ cell }) => (
                    <Typography
                        variant="body2"
                        noWrap
                        sx={{
                            minWidth: 350,
                            maxWidth: 350,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                        title={cell.getValue() || '-'}
                    >
                        {cell.getValue() || '-'}
                    </Typography>
                ),
            },
            {
                accessorKey: 'papelPrincipal',
                header: 'Papel Principal',
            },
            {
                accessorKey: 'status',
                header: 'Status',
                Cell: ({ cell }) => {
                    const value = cell.getValue();

                    let color = 'success';

                    if (value === 'Atrasado') color = 'error';
                    else if (value === 'Pendente') color = 'warning';

                    return <Chip label={value || '-'} color={color} size="small" />;
                },
            },
            {
                accessorKey: 'itens',
                header: 'Qtd. Itens',
            },
            {
                accessorKey: 'registros',
                header: 'Qtd. Registros',
            },
        ],
        []
    );

    return (
        <div>
            {dialogs.openDeleteDialog && (
                <CustomDialog
                    title="Delete PARTICIPANTE!"
                    content="Você tem certeza?"
                    onClose={actions.handleCancelar}
                    onConfirm={actions.handleDeletar}
                />
            )}

            {dialogs.openDialog && (
                <HomologationPessoaDialog
                    open={dialogs.openDialog}
                    onClose={actions.handleCancelar}
                    onSave={actions.handleSalvarDraft}
                    formData={dialogs.draft}
                    pessoaId={context.pessoaId}
                    empresaId={context.empresaId}
                    empresaIds={context.empresaIds}
                    empresaTabelaId={context.empresaTabelaId}
                />
            )}

            <MaterialReactTable
                columns={columns}
                data={state.rows}
                enableRowSelection
                enableRowActions
                getRowId={(row) => row.uuid}
                manualFiltering
                manualPagination
                manualSorting
                enableColumnFilterModes
                enableGlobalFilterModes
                enableColumnOrdering
                localization={MRT_Localization_PT_BR}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        size: 100,
                    },
                }}
                renderTopToolbarCustomActions={() => (
                    <Box sx={{ display: 'flex', gap: '8px' }}>
                        <Tooltip title="Novo Participante">
                            <Button variant="contained" color="secondary" startIcon={<Add />} onClick={actions.handleAdicionar}>
                                Novo Participante
                            </Button>
                        </Tooltip>
                    </Box>
                )}
                renderRowActions={({ row }) => (
                    <Box sx={{ display: 'flex', gap: '0.5rem' }}>
                        <Tooltip title="Editar">
                            <IconButton onClick={() => actions.handleEditar(row)}>
                                <Edit />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Deletar">
                            <IconButton
                                color="error"
                                onClick={() => {
                                    actions.setSelectedRow(row.original);
                                    actions.setOpenDeleteDialog(true);
                                }}
                            >
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
                onColumnFiltersChange={mrt.setColumnFilters}
                onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                onGlobalFilterChange={mrt.setGlobalFilter}
                onPaginationChange={mrt.setPagination}
                onSortingChange={mrt.setSorting}
                rowCount={mrt.rowCount}
                initialState={{
                    showColumnFilters: true,
                    density: 'compact',
                }}
                state={{
                    columnFilterFns: mrt.columnFilterFns,
                    columnFilters: mrt.columnFilters,
                    globalFilter: mrt.globalFilter,
                    isLoading: mrt.isLoading,
                    pagination: mrt.pagination,
                    showAlertBanner: mrt.isError,
                    showProgressBars: mrt.isRefetching,
                    sorting: mrt.sorting,
                }}
                muiToolbarAlertBannerProps={
                    mrt.isError
                        ? {
                              color: 'error',
                              children: 'Erro ao carregar participantes',
                          }
                        : undefined
                }
                positionActionsColumn="first"
                positionToolbarAlertBanner="bottom"
            />
        </div>
    );
}

export default PessoasTabPanel;
